import React, {Component,  useState, useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as commonActions from '@common/common.action';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, FormGroup, Label, Input, Badge } from 'reactstrap';
import IntlMessage from '../../../../../helpers/intlMessage';
import WebapiCommon from '@common/util/webapi.common';
import TabPane from 'reactstrap/lib/TabPane';
import TabContent from 'reactstrap/lib/TabContent';
import Nav from 'reactstrap/lib/Nav';
import NavItem from 'reactstrap/lib/NavItem';
import NavLink from 'reactstrap/lib/NavLink';
import classnames from 'classnames';
import SelectComponent from '@componentes/select/select.component';
import { useIntl } from 'react-intl';
import { editorUrl, editorRunat } from '@constants/defaultValues';
import { DebounceInput } from 'react-debounce-input';
import './siscolo.modal.styles.css';
import CheckBox from '@componentes/checkbox/checkbox.component';
import { LOCAL_STORAGE_USUARIO } from '../../../../../localStorage.util';
import EditorContainer from '@componentes/editor/editor.container';
import { useHistory } from 'react-router-dom';
import * as editorActions from '@componentes/editor/editor.action';
import * as editorUtil from '../../../../../componentes/editor/editor.util';
import { errors } from '../../../../../pages/error/erros';
import { formatDate } from '../../../../../../src/helpers';
import * as constantes from './siscolo.constantes';


function SiscoloModal(props) {
    const [toggleTab, setToggleTab] = useState('1');
    const [papanicolauSelecionado, setPapanicolauSelecionado] = useState(null);
    const [radioTerapiaSelecionado, setRadioTerapiaSelecionado] = useState(null);
    const [diuSelecionado, setDiuSelecionado] = useState(null);
    const [anoPapaNicolau, setAnoPapaNicolau] = useState(null);
    const [sangramentoRelacaoSexual, setSangramentoRelacaoSexual] = useState(null);
    const [sangramentoAposMenopausa, setSangramentoAposMenopausa] = useState(null);
    const [gravides, setGravides] = useState(null);
    const [pilula, setPilula] = useState(null);
    const [hormonioMenopausa, setHormonioMenopausa] = useState(null);
    const [doencaSexualmenteTransmissivel, setDoencaSexualmenteTransmissivel] = useState(null);
    const [dataUltimaMestruacao, setDataUltimaMestruacao] = useState(null);
    const [datareRecebimentoMaterial, setDatareRecebimentoMaterial] = useState(null);
    const [dataColeta, setDataColeta] = useState(null);
    const [tipoMestruacaoSeletionado, setTipoMestruacaoSeletionado] = useState(null);
    const [inspecaoColo, setInspecaoColo] = useState(null);
    const [rejeitada, setRejeitada] = useState(null);
    const [laminaDanificada, setLaminaDanificada] = useState(null);
    const [causasAlheiasRejeicao, setCausasAlheiasRejeicao] = useState(null);
    const [outrasCausasRejeicao, setOutrasCausasRejeicao] = useState(null);
    const [adequabilidade, setAdequabilidade] = useState(constantes.adequabilidadeOptions[0]);
    const [acelularHipocelular, setAcelularHipocelular] = useState(null);
    const [sangueEsfregaco, setSangueEsfregaco] = useState(null);
    const [contaminantes, setContaminantes] = useState(null);
    const [artefatosDessecamento, setArtefatosDessecamento] = useState(null);
    const [superposicao, setSuperposicao] = useState(null);
    const [outros, setOutros] = useState(null);
    const [escamoso, setEscamoso] = useState(null);
    const [glandular, setGlandular] = useState(null);
    const [metaplasico, setMetaplasico] = useState(null);
    const [pioticosEsfregaco, setPioticosEsfregaco] = useState(null);
    const [limiteNormalidade, setLimiteNormalidade] = useState(null);
    const [metaplasiaescamosa, setMetaplasiaescamosa] = useState(null);
    const [reparacao, setReparacao] = useState(null);
    const [atrofiaInflamacao, setAtrofiaInflamacao] = useState(null);
    const [inflamacao, setInflamacao] = useState(null);
    const [radiacao, setRadiacao] = useState(null);
    const [outrosMotivos, setOutrosMotivos] = useState(null);
    const [trichomonas, setTrichomonas] = useState(null);
    const [cocos, setCocos] = useState(null);
    const [lactobacillus, setLactobacillus] = useState(null);
    const [efeitocitopatico, setEfeitocitopatico] = useState(null);
    const [chlamydia, setChlamydia] = useState(null);
    const [gardnerella, setGardnerella] = useState(null);
    const [actinomyces, setActinomyces] = useState(null);
    const [bacilos, setBacilos] = useState(null);
    const [baciloSupracitopaticos, setBaciloSupracitopaticos] = useState(null);
    const [candida, setCandida] = useState(null);
    const [celulaEscamosa, setCelulaEscamosa] = useState(constantes.tiposcelupasatipiasOtions[0]);
    const [celulaGanlurares, setCelulaGanlurares] = useState(constantes.tiposcelupasatipiasOtions[0]);
    const [celulaOrigemIndefinida, setCelulaOrigemIndefinida] = useState(null);
    const [outrosMotivosMicrobiologia, setOutrosMotivosMicrobiologia] = useState(null);
    const [atipiasCelulasEscamosas, setAtipiasCelulasEscamosas] = useState(constantes.atipiasEmCelupasEscamosasOptions[0]);
    const [atipiasCelulasGlandulares, setAtipiasCelulasGlandulares] = useState(constantes.atipiasEmCelupasGlandularesOptions[0]);
    const [outrasNeoplasiasMalignas, setOutrasNeoplasiasMalignas] = useState(null);
    const [celulaEndometria, setCelulaEndometria] = useState(null);
    const [observacaosGerais, setObservacacaosGerais] = useState(null);
    const [dataLiberacao, setDataLiberacao] = useState(null);
    const [medicoResponsavel, setMedicoResponsavel] = useState(null);
    const [unidadeAtendimento, setUnidadeAtendimento] = useState([]);
    const [competenciaFaturamento, setCompetenciaFaturamento] = useState([]);
    const [medicoResponsavelOptions, setMedicoResponsavelOptions] = useState([]);
    const [unidadeAtendimentoOptipons, setUnidadeAtendimentoOptipons] = useState([]);
    const [competenciaFaturamentoOptions, setCompetenciaFaturamentoOptions] = useState([]);
    const [textoResumo, setTextoResumo] = useState('');
    const [enviaInfoMv, setEnviaInfoMv] = useState(false);
    const editorInicializado = useSelector(
        (state) => state.editorComponent.editorCarregado
    );
    const [inicializado, setInicializado] = useState(false);

    const intl = useIntl();
    const { messages } = intl;
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        if (toggleTab) {
            substituirTextoEditor(constantes.templateRtfSiscolo);
            console.log(toggleTab);
        }

    }, [toggleTab]);

    useEffect(() => {
        window.addEventListener('message', ({ data }) => {
            if (data.value) {
                if (data.value.plain) {
                    setInicializado(true);
                }
            }
        });

        return () => {
            window.removeEventListener('message', null, true);
            setInicializado(false);
        };
    }, []);


    useEffect(() => {
        let medicosList = [];
        let unidadesList = [];
        let competencias = [];
        if ((!medicoResponsavelOptions || medicoResponsavelOptions.length === 0 ) && props.detalhesLaudo.siscolo) {
            dispatch(commonActions.showFadeCarregando(true));
            WebapiCommon.getMedicos().then(medicos => {
                setMedicoResponsavelOptions(medicos);
                medicosList = medicos;
                const usuarioLocal = JSON.parse(
                    localStorage.getItem(LOCAL_STORAGE_USUARIO)
                );

                if (usuarioLocal && usuarioLocal.medicoId && medicoResponsavel === null) {
                    let medico = medicos.find(
                        medico => medico.value === usuarioLocal.medicoId
                    );

                    setMedicoResponsavel(medico);
                }

                WebapiCommon.getUnidadesSiscolo().then(unidades => {
                    setUnidadeAtendimentoOptipons(unidades.data);
                    unidadesList = unidades.data;

                    if (props.detalhesLaudo.unidadeOrigemAtendimentoId && props.detalhesLaudo.unidadeOrigemAtendimentoId > 0) {
                        let unidade = unidades.data.find(
                            unidade => unidade.value === props.detalhesLaudo.unidadeOrigemAtendimentoId
                        );
                        setUnidadeAtendimento(unidade);
                    }
                    WebapiCommon.getCompetenciasFaturamento(props.detalhesLaudo.cd_Multi_Empresa).then(c => {
                        setCompetenciaFaturamentoOptions(c.data);
                        competencias = c.data;

                        WebapiCommon.getInformacoesSiscolo(props.detalhesLaudo.laudo).then(info => {
                            if (info.data) {
                                atualizarDadosinformacoesBanco(info.data.papanicolauSelecionado, setPapanicolauSelecionado, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.limiteNormalidade, setLimiteNormalidade);
                                atualizarDadosinformacoesBanco(info.data.inflamacao, setInflamacao);
                                atualizarDadosinformacoesBanco(info.data.metaplasiaescamosa, setMetaplasiaescamosa);
                                atualizarDadosinformacoesBanco(info.data.reparacao, setReparacao);
                                atualizarDadosinformacoesBanco(info.data.atrofiaInflamacao, setAtrofiaInflamacao);
                                atualizarDadosinformacoesBanco(info.data.radiacao, setRadiacao);
                                atualizarDadosinformacoesBanco(info.data.outrosMotivos, setOutrosMotivos);
                                atualizarDadosinformacoesBanco(info.data.papanicolauSelecionado !== 'N' ? info.data.anoPapaNicolau: null, setAnoPapaNicolau);
                                atualizarDadosinformacoesBanco(info.data.medicoResponsavel, setMedicoResponsavel, medicoResponsavelOptions);
                                atualizarDadosinformacoesBanco(info.data.unidadeAtendimento, setUnidadeAtendimento, unidadeAtendimentoOptipons);
                                atualizarDadosinformacoesBanco(info.data.competenciaFaturamento, setCompetenciaFaturamento, competenciaFaturamentoOptions);
                                atualizarDadosinformacoesBanco(info.data.radioTerapiaSelecionado, setRadioTerapiaSelecionado, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.diuSelecionado, setDiuSelecionado, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.sangramentoRelacaoSexual, setSangramentoRelacaoSexual, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.sangramentoAposMenopausa, setSangramentoAposMenopausa, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.gravides, setGravides, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.pilula, setPilula, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.hormonioMenopausa, setHormonioMenopausa, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.doencaSexualmenteTransmissivel, setDoencaSexualmenteTransmissivel, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.tipoMestruacaoSeletionado, setTipoMestruacaoSeletionado, constantes.siscoloOptions);
                                atualizarDadosinformacoesBanco(info.data.dataUltimaMestruacao, setDataUltimaMestruacao);
                                atualizarDadosinformacoesBanco(info.data.datareRecebimentoMaterial, setDatareRecebimentoMaterial);
                                atualizarDadosinformacoesBanco(info.data.inspecaoColo, setInspecaoColo);
                                atualizarDadosinformacoesBanco(info.data.rejeitada, setRejeitada);
                                atualizarDadosinformacoesBanco(info.data.laminaDanificada, setLaminaDanificada);
                                atualizarDadosinformacoesBanco(info.data.causasAlheiasRejeicao, setCausasAlheiasRejeicao);
                                atualizarDadosinformacoesBanco(info.data.outrasCausasRejeicao, setOutrasCausasRejeicao);
                                atualizarDadosinformacoesBanco(info.data.adequabilidade, setAdequabilidade, constantes.adequabilidadeOptions);
                                atualizarDadosinformacoesBanco(info.data.acelularHipocelular, setAcelularHipocelular);
                                atualizarDadosinformacoesBanco(info.data.sangueEsfregaco, setSangueEsfregaco);
                                atualizarDadosinformacoesBanco(info.data.contaminantes, setContaminantes);
                                atualizarDadosinformacoesBanco(info.data.artefatosDessecamento, setArtefatosDessecamento);
                                atualizarDadosinformacoesBanco(info.data.superposicao, setSuperposicao);
                                atualizarDadosinformacoesBanco(info.data.outros, setOutros);
                                atualizarDadosinformacoesBanco(info.data.escamoso, setEscamoso);
                                atualizarDadosinformacoesBanco(info.data.glandular, setGlandular);
                                atualizarDadosinformacoesBanco(info.data.metaplasico, setMetaplasico);
                                atualizarDadosinformacoesBanco(info.data.pioticosEsfregaco, setPioticosEsfregaco);
                                atualizarDadosinformacoesBanco(info.data.trichomonas, setTrichomonas);
                                atualizarDadosinformacoesBanco(info.data.cocos, setCocos);
                                atualizarDadosinformacoesBanco(info.data.lactobacillus, setLactobacillus);
                                atualizarDadosinformacoesBanco(info.data.efeitocitopatico, setEfeitocitopatico);
                                atualizarDadosinformacoesBanco(info.data.chlamydia, setChlamydia);
                                atualizarDadosinformacoesBanco(info.data.gardnerella, setGardnerella);
                                atualizarDadosinformacoesBanco(info.data.actinomyces, setActinomyces);
                                atualizarDadosinformacoesBanco(info.data.bacilos, setBacilos);
                                atualizarDadosinformacoesBanco(info.data.baciloSupracitopaticos, setBaciloSupracitopaticos);
                                atualizarDadosinformacoesBanco(info.data.candida, setCandida);
                                atualizarDadosinformacoesBanco(info.data.celulaEscamosa, setCelulaEscamosa, constantes.tiposcelupasatipiasOtions);
                                atualizarDadosinformacoesBanco(info.data.celulaGanlurares, setCelulaGanlurares, constantes.tiposcelupasatipiasOtions);
                                atualizarDadosinformacoesBanco(info.data.celulaOrigemIndefinida, setCelulaOrigemIndefinida, constantes.tiposcelupasatipiasOtions);
                                atualizarDadosinformacoesBanco(info.data.outrosMotivosMicrobiologia, setOutrosMotivosMicrobiologia);
                                atualizarDadosinformacoesBanco(info.data.atipiasCelulasEscamosas, setAtipiasCelulasEscamosas, constantes.atipiasEmCelupasEscamosasOptions);
                                atualizarDadosinformacoesBanco(info.data.atipiasCelulasGlandulares, setAtipiasCelulasGlandulares, constantes.atipiasEmCelupasGlandularesOptions);
                                atualizarDadosinformacoesBanco(info.data.outrasNeoplasiasMalignas, setOutrasNeoplasiasMalignas);
                                atualizarDadosinformacoesBanco(info.data.celulaEndometria, setCelulaEndometria);
                                atualizarDadosinformacoesBanco(info.data.observacaosGerais, setObservacacaosGerais);
                                atualizarDadosinformacoesBanco(info.data.dataLiberacao, setDataLiberacao);
                                atualizarDadosinformacoesBanco(info.data.dataColeta, setDataColeta);
                                atualizarDadosinformacoesBanco(info.data.inspecaoColo, setInspecaoColo, constantes.inspecaoColoOptions);
                                atualizarDadosinformacoesBanco(info.data.medicoResponsavel, setMedicoResponsavel, medicosList);
                                atualizarDadosinformacoesBanco(info.data.unidadeAtendimento, setUnidadeAtendimento, unidadesList);
                                atualizarDadosinformacoesBanco(info.data.id_Faturamento, setCompetenciaFaturamento, competencias);
                                setInicializado(true);
                            }
                            else
                            {
                                setInicializado(true);
                            }

                            substituirTextoEditor(constantes.templateRtfSiscolo);

                            dispatch(commonActions.showFadeCarregando(false));
                        });
                    });
                });
            });

        }
    }, [medicoResponsavelOptions, unidadeAtendimentoOptipons]);

    function atualizarDadosinformacoesBanco(value, setter, options = null) {
        if (options) {
            const newValue = options.find(option => option.value === value);
            setter(newValue);
        }
        else {
            setter(value);
        }
    }

    useEffect(() => {
        if (limiteNormalidade) {
            setInflamacao(false);
            setMetaplasiaescamosa(false);
            setReparacao(false);
            setAtrofiaInflamacao(false);
            setRadiacao(false);
            setOutrosMotivos('');
        }

    }, [limiteNormalidade]);

    useEffect(() => {
        if (limiteNormalidade) {
            setInflamacao(false);
            setMetaplasiaescamosa(false);
            setReparacao(false);
            setAtrofiaInflamacao(false);
            setRadiacao(false);
            setOutrosMotivos('');
        }

    }, [limiteNormalidade]);

    useEffect(() => {
        if (!papanicolauSelecionado || papanicolauSelecionado.value !== 'S') {
            setAnoPapaNicolau(null);
        }

    }, [papanicolauSelecionado]);

    useEffect(() => {
        if (rejeicaoMaterialSelecionada()) {
            setAdequabilidade(constantes.adequabilidadeOptions[0]);

            if (!habilitarCheckboxAdequabilidade()) {
                setAcelularHipocelular(false);
                setSangueEsfregaco(false);
                setPioticosEsfregaco(false);
                setArtefatosDessecamento(false);
                setContaminantes(false);
                setSuperposicao(false);
                setSuperposicao(false);
                setOutros(false);
            }
        }


    }, [rejeitada, laminaDanificada, causasAlheiasRejeicao, outrasCausasRejeicao]);

    useEffect(() => {
        dispatch(editorActions.showEditor(true));
        dispatch(editorActions.editorAltura('600px'));
        if (props.isOpen) {
            dispatch(commonActions.showFadeCarregando(true));
            carregarEditor(true);
            if (editorInicializado) {
                substituirTextoEditor(constantes.templateRtfSiscolo);
                dispatch(commonActions.showFadeCarregando(false));
            }
        } else {
            dispatch(commonActions.showFadeCarregando(false));
        }
    }, [props.isOpen]);

    const toggle = tab => {
        if (toggleTab !== tab) {
            const aba = document.getElementById(`tab${tab}`);
            if (tab < 6) {
                setToggleTab(tab);
                aba.click();
            }
        }
    };

    function campoObrigatorioHint() {
        return (inicializado) && (<div><p style={{ color: 'red' }}>Preenchimento obrigatório</p></div>);
    }

    const payload = () => {
        return {
            laudo: props.detalhesLaudo.laudo,
            papanicolauSelecionado: papanicolauSelecionado.value,
            anoPapaNicolau: anoPapaNicolau,
            radioTerapiaSelecionado: radioTerapiaSelecionado.value,
            diuSelecionado: diuSelecionado.value,
            sangramentoRelacaoSexual: sangramentoRelacaoSexual.value,
            sangramentoAposMenopausa: sangramentoAposMenopausa.value,
            gravides: gravides.value,
            pilula: pilula.value,
            hormonioMenopausa: hormonioMenopausa ? hormonioMenopausa.value : null,
            doencaSexualmenteTransmissivel: doencaSexualmenteTransmissivel ? doencaSexualmenteTransmissivel.value : null,
            tipoMestruacaoSeletionado: tipoMestruacaoSeletionado ? tipoMestruacaoSeletionado.value : null,
            dataUltimaMestruacao: dataUltimaMestruacao,
            datareRecebimentoMaterial: datareRecebimentoMaterial,
            dataColeta: dataColeta,
            id_Faturamento: competenciaFaturamento ? competenciaFaturamento.value : null,
            inspecaoColo: inspecaoColo.value,
            rejeitada: rejeitada,
            laminaDanificada: laminaDanificada,
            causasAlheiasRejeicao: causasAlheiasRejeicao,
            outrasCausasRejeicao: outrasCausasRejeicao,
            adequabilidade: adequabilidade ? adequabilidade.value : null,
            acelularHipocelular: acelularHipocelular,
            sangueEsfregaco: sangueEsfregaco,
            contaminantes: contaminantes,
            artefatosDessecamento: artefatosDessecamento,
            superposicao: superposicao,
            outros: outros,
            escamoso: escamoso,
            glandular: glandular,
            metaplasico: metaplasico,
            pioticosEsfregaco: pioticosEsfregaco,
            limiteNormalidade: limiteNormalidade,
            metaplasiaescamosa: metaplasiaescamosa,
            reparacao: reparacao,
            atrofiaInflamacao: atrofiaInflamacao,
            inflamacao: inflamacao,
            radiacao: radiacao,
            outrosMotivos: outrosMotivos,
            trichomonas: trichomonas,
            cocos: cocos,
            lactobacillus: lactobacillus,
            efeitocitopatico: efeitocitopatico,
            chlamydia: chlamydia,
            gardnerella: gardnerella,
            actinomyces: actinomyces,
            bacilos: bacilos,
            baciloSupracitopaticos: baciloSupracitopaticos,
            candida: candida,
            celulaEscamosa: celulaEscamosa ? celulaEscamosa.value : "X",
            celulaGanlurares: celulaGanlurares ? celulaGanlurares.value : "X",
            celulaOrigemIndefinida: celulaOrigemIndefinida ? celulaOrigemIndefinida.value : null,
            outrosMotivosMicrobiologia: outrosMotivosMicrobiologia,
            atipiasCelulasEscamosas: atipiasCelulasEscamosas ? atipiasCelulasEscamosas.value : "X",
            atipiasCelulasGlandulares: atipiasCelulasGlandulares ? atipiasCelulasGlandulares.value : "X",
            outrasNeoplasiasMalignas: outrasNeoplasiasMalignas && outrasNeoplasiasMalignas.trim() !== '' ? outrasNeoplasiasMalignas : null,
            celulaEndometria: celulaEndometria,
            observacaosGerais: observacaosGerais ? observacaosGerais : '',
            dataLiberacao: dataLiberacao,
            medicoResponsavel: medicoResponsavel.value,
            unidadeAtendimento: unidadeAtendimento.value,
            textoResumo: atob(textoResumo),
            enviaInfoMV: enviaInfoMv
        };
    };

    function salvar(e) {
        if (preenchimentoValido()) {
            dispatch(commonActions.showFadeCarregando(true));
            WebapiCommon.salvarInformacoesSiscolo(payload()).then((response) => {

                if (response.data && response.data === true) {
                    dispatch(commonActions.showAlerta('sucesso', 'Informações salvas com sucesso', 2000));
                    localStorage.removeItem('texto_' + props.detalhesLaudo.laudo + '_micro');
                    dispatch(editorActions.editorRtf(textoResumo));
                    dispatch(commonActions.changeRtf(textoResumo));
                    props.onClose();
                    props.toggle(false);
                    setTimeout(() => {
                        dispatch(commonActions.showFadeCarregando(false));
                    },300);
                }
                else {
                    dispatch(commonActions.showAlerta('erro', 'Erro ao salvar informações', 2000));
                }
            });
        }
        else {
            dispatch(commonActions.showAlerta('alerta', 'favor preencher campos obrigátorios'), 2000);
        }
    }

    function rejeicaoMaterialSelecionada() {
        return rejeitada || laminaDanificada || (outrasCausasRejeicao && outrasCausasRejeicao !== '') || (causasAlheiasRejeicao && causasAlheiasRejeicao !== '');
    }

    function getObjetoSubstituir(valor, outrovalor = null) {
        let textoAdicional = '';
        if (outrovalor) {
            textoAdicional = ' (' + outrovalor + ')';
        }

        return valor && valor.label ? valor.label + textoAdicional : valor ? valor + textoAdicional : constantes.semInformacoes;
    }

    function joinArray(array) {
        let newArray = [];
        array.forEach(element => {
            if (element) {
                newArray.push(element);
            }
        })

        return newArray.join('<br>');
    }

    function montarTextoAvaliacaoPreAnalitica() {
        let array = [];
        if (rejeicaoMaterialSelecionada()) {
            array.push(rejeitada ? constantes.ausenciaErroIdentificacaoLabel : null,
                laminaDanificada ? constantes.laminaDanificadaouAusenteLabel : null,
                causasAlheiasRejeicao, outrasCausasRejeicao);
        }
        else {
            array.push(adequabilidade && adequabilidade ? adequabilidade.label : '',
                acelularHipocelular ? constantes.acelularHipocelularLabel : null,
                sangueEsfregaco ? constantes.sangueEsfregacoLabel : null,
                pioticosEsfregaco ? constantes.pioticosEsfregacoLabel : null,
                contaminantes ? constantes.contaminantesLabel : null,
                artefatosDessecamento ? constantes.artefatosDessecamentoLabel : null,
                superposicao ? constantes.intensaSuperposicaoLabel : null,
                outros ? 'Outros' : null);
        }

        return joinArray(array);
    }

    function montarTextoAvaliacaoPreAnalitica2() {
        let array = [];
        if (adequabilidade && adequabilidade.value === 'S') {
            array.push(escamoso ? 'Escamoso' : null, glandular ? 'Glandular' : null, metaplasico ? 'Metaplásico' : null);
            return joinArray(array);
        }
        else {
            return '';
        }
    }

    const microbiologiaSelecionada = () => {
        return (lactobacillus)
            || (trichomonas) || (cocos) || (efeitocitopatico)
            || (chlamydia) || (gardnerella) || (actinomyces)
            || (bacilos) || (candida) || (baciloSupracitopaticos)
            || (outrosMotivosMicrobiologia && outrosMotivosMicrobiologia.trim() !== '');
    }

    function montarTextoDiagnosticoDescritivo() {
        if (limiteNormalidade) {
            return constantes.dentroLimitesLabel;
        }
        else {
            const array = [constantes.alteracoesCelularesBenignasReativasLabel,
            inflamacao ? constantes.inflamacaoLabel : null,
            metaplasiaescamosa ? constantes.metaplasiaescamosaLabel : null,
            reparacao ? constantes.reparacaoLabel : null,
            atrofiaInflamacao ? constantes.atrofiaInflamacaoLabel : null,
            radiacao ? constantes.radiacaoLabel : null,
            outrosMotivos ? outrosMotivos : null
            ];

            if (microbiologiaSelecionada) {
                array.push('  ');
                array.push('Microbiologia');
                array.push(lactobacillus ? constantes.lactobacillusspLabel : null);
                array.push(trichomonas ? constantes.trichomonasVaginalisLabel : null);
                array.push(cocos ? constantes.cocosLabel : null);
                array.push(efeitocitopatico ? constantes.efeitocitopaticoLabel : null);
                array.push(chlamydia ? constantes.chlamydiaSpLabel : null);
                array.push(gardnerella ? constantes.gardnerellaVaginalisLabel : null);
                array.push(actinomyces ? constantes.actinomycesSpLabel : null);
                array.push(bacilos ? constantes.bacilosLabel : null);
                array.push(candida ? constantes.candidaSpLabel : null);
                array.push(baciloSupracitopaticos ? constantes.bacilossupracitopaticosLabel : null);
                array.push(outrosMotivosMicrobiologia ? outrosMotivosMicrobiologia : null);
            }

            return joinArray(array);
        }
    }

    function montarTextoConclusao() {
        let array = [];

        if (celulaEscamosa && celulaEscamosa.value !== 'X') {
            array.push(
                'Células atipicas escamosas de significado indeterminado:',
                celulaEscamosa.label,
                ' '
            );
        }

        if (celulaGanlurares && celulaGanlurares.value !== 'X') {
            array.push(
                'Células atipicas glandulares de significado indeterminado:',
                celulaGanlurares.label,
                ' '
            );
        }

        if (celulaOrigemIndefinida && celulaOrigemIndefinida.value !== 'X') {
            array.push(
                'Células atipicas de origem indefinida de significado indeterminado:',
                celulaOrigemIndefinida.label,
                ' '
            );
        }

        if (atipiasCelulasEscamosas && atipiasCelulasEscamosas.value !== 'X') {
            array.push(
                'Atipia em células escamosas:',
                atipiasCelulasEscamosas.label,
                ' '
            );
        }

        if (atipiasCelulasGlandulares && atipiasCelulasGlandulares.value !== 'X') {
            array.push(
                'Atipia em células glandulares:',
                atipiasCelulasGlandulares.label,
                ' '
            );
        }

        if (outrasNeoplasiasMalignas && outrasNeoplasiasMalignas.trim() !== '') {
            array.push(
                constantes.outrasNeoplasiasMalignasLabel + ':',
                outrasNeoplasiasMalignas,
                ' '
            );
        }

        if (celulaEndometria) {
            array.push(
                constantes.presencaCelulasendometraisLabel,
                ' '
            );
        }

        if (array.length > 0) {
            return joinArray(array);
        }
        else {
            return constantes.negativoNeoplasia;
        }

    }

    const substituirTextoEditor = (texto) => {
        const frame = document.getElementById('iframe-editor-component');
        let text = atob(texto);
        const payloadVariaveis = {
            template: text, variaveis: [
                { nome: '&PAPANICOLAU', valor: getObjetoSubstituir(papanicolauSelecionado, anoPapaNicolau ? anoPapaNicolau : '') },
                { nome: '&DIU', valor: getObjetoSubstituir(diuSelecionado) },
                { nome: '&GRAVIDA', valor: getObjetoSubstituir(gravides) },
                { nome: '&PILULA', valor: getObjetoSubstituir(pilula) },
                { nome: '&HORMONIO', valor: getObjetoSubstituir(hormonioMenopausa) },
                { nome: '&RADIOTERAPIA', valor: getObjetoSubstituir(radioTerapiaSelecionado) },
                { nome: '&MENSTRUACAO', valor: getObjetoSubstituir(tipoMestruacaoSeletionado, dataUltimaMestruacao ? formatDate(dataUltimaMestruacao, true) : '') },
                { nome: '&SANGRAMENTO_RELACAO', valor: getObjetoSubstituir(sangramentoRelacaoSexual) },
                { nome: '&SANGRAMENTO_MENOPAUSA', valor: getObjetoSubstituir(sangramentoAposMenopausa) },
                { nome: '&INSPECAO_COLO', valor: getObjetoSubstituir(inspecaoColo) },
                { nome: '&DST', valor: getObjetoSubstituir(doencaSexualmenteTransmissivel) },
                { nome: '&TITULO_AVALICAO_PRE_ANALITICA_1', valor: getObjetoSubstituir(rejeitada ? 'Amostra rejeitada por' : 'Adequabilidade do material') },
                { nome: '&TEXTO_AVALICAO_PRE_ANALITICA_1', valor: getObjetoSubstituir(montarTextoAvaliacaoPreAnalitica()) },
                { nome: '&TITULO_AVALICAO_PRE_ANALITICA_2', valor: getObjetoSubstituir(adequabilidade && adequabilidade.value === 'I' ? 'Epitélios representados na amostra' : '') },
                { nome: '&TEXTO_AVALICAO_PRE_ANALITICA_2', valor: getObjetoSubstituir(montarTextoAvaliacaoPreAnalitica2()) },
                { nome: '&DIAGNOSTICO_DESCRITIVO', valor: getObjetoSubstituir(montarTextoDiagnosticoDescritivo()) },
                { nome: '&CONCLUSAO', valor: getObjetoSubstituir(montarTextoConclusao()) },
                { nome: '&OBSERVACOESGERAIS', valor: getObjetoSubstituir(observacaosGerais ? observacaosGerais : '') }
            ]
        };

        WebapiCommon.GetSiscoloVariaveis(payloadVariaveis).then((response) => {
            if (response && response.data) {
                text = btoa(response.data);

                setTextoResumo(text);

                frame.contentWindow.postMessage(
                    {
                        method: 'substituirTexto',
                        text: text,
                        type: 'rtf',
                        runat: editorRunat,
                        breakLine: false,
                        cleanBefore: true,
                        readOnly: true
                    },
                    editorUrl
                );
                dispatch(editorActions.editorRtf(text));
            }
        })

    }

    const preenchimentoValido = () => {

        if (toggleTab) {
            switch (toggleTab) {
                case '1':

                return ((papanicolauSelecionado && papanicolauSelecionado.value !== 'S')
                        || (papanicolauSelecionado && papanicolauSelecionado.value === 'S' && anoPapaNicolau))
                        && radioTerapiaSelecionado && diuSelecionado && gravides &&
                        (tipoMestruacaoSeletionado && tipoMestruacaoSeletionado.value !== 'S' || (tipoMestruacaoSeletionado && tipoMestruacaoSeletionado.value === 'S' && dataUltimaMestruacao))
                        && sangramentoRelacaoSexual && pilula && hormonioMenopausa && sangramentoAposMenopausa && inspecaoColo && doencaSexualmenteTransmissivel
                        && dataColeta && datareRecebimentoMaterial;
                case '2':
                    return (!habiltarAdequabilidade() || (adequabilidade && adequabilidade.value !== 'I') &&
                    (habilitarEpitelios() && (metaplasico || glandular || escamoso))) || ((adequabilidade && adequabilidade.value === 'I')
                        && (acelularHipocelular || acelularHipocelular || acelularHipocelular || sangueEsfregaco || pioticosEsfregaco || contaminantes
                            || superposicao || outros) || !habiltarAdequabilidade()) && (!habilitarEpitelios());

                case '3': return limiteNormalidade || (inflamacao || metaplasiaescamosa || reparacao || atrofiaInflamacao || radiacao || (outrosMotivos && outrosMotivos !== ''));
                case '4': return celulaOrigemIndefinida && ((celulaEscamosa && celulaEscamosa.value !== 'X') || (atipiasCelulasEscamosas && atipiasCelulasEscamosas.value !== 'X'))
                    && ((celulaGanlurares && celulaGanlurares.value !== 'X') || (atipiasCelulasGlandulares && atipiasCelulasGlandulares.value !== 'X')) && dataLiberacao && medicoResponsavel;

                default:
                    return  true;
            }
        }
        else return false;

    }
    const habilitarCheckboxAdequabilidade = () => {
        if (adequabilidade && adequabilidade.value === 'I') {
            return true;
        }
        return false;
    }

    const onChangeAdequabilidade = (e) => {
        if(e && e.value === 'I'){
            setAcelularHipocelular(false);
            setSangueEsfregaco(false);
            setPioticosEsfregaco(false);
            setArtefatosDessecamento(false);
            setContaminantes(false);
            setSuperposicao(false);
            setOutros(false);
        }
        else if(e && e.value === 'S'){
             setEscamoso(false);
             setGlandular(false);
             setMetaplasico(false);
        }

        setAdequabilidade(e);
    }

    function habilitarEpitelios() {
        if (adequabilidade && adequabilidade.value === 'S'){
            return true;
        }
        return false;
    }

    const habiltarAdequabilidade = () => {
        return !(rejeitada || laminaDanificada || causasAlheiasRejeicao || outrasCausasRejeicao);
    }

    const onchangeTipoMestruacao = (e) => {
        setTipoMestruacaoSeletionado(e);

        if (!e || !e.value || e.value !== 'S') {
            setDataUltimaMestruacao(null);
        }
    }

    function carregarEditor(blank = true) {
        try {
            editorUtil.Inicializar(props.detalhesLaudo.laudo, 'MICRO', dispatch, blank);
        } catch (error) {
            const { message } = error;
            let title = '';
            const origin = 'Modal Siscolo';
            const code = 101;

            errors.map((err) => {
                if (err.code === code) {
                    title = err.title;
                }
                return err;
            });
            window.location.replace(
                `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
            );
        }
    }

    const validarDataInformada = (value, setter) => {
        const timeDataPreenchida = new Date(value).getTime();
        const timeDataAtual = new Date().getTime();

        if (timeDataPreenchida < timeDataAtual) {
            setter(value);
        } else {
            dispatch(commonActions.showAlerta('alerta', 'A data escolhida é posterior a data atual !', 3000));
            setter(' ');
        }
    }

    return (
        <div className='mv-container siscolo-modal'>
            <div className='siscolo-modal'>
                <Modal size='xl' isOpen={props.isOpen} toggle={props.toggle} className='siscolo-modal Content' backdrop="static">
                    <ModalHeader>
                        <IntlMessage id="dashboard.siscolo.modal.title" /> {props.detalhesLaudo.prontuario} - {props.detalhesLaudo.paciente}
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xl={8}>
                                <FormGroup>
                                    <Label>
                                        <IntlMessage id="Unidade de atendimento" />
                                    </Label>
                                    <SelectComponent
                                        value={unidadeAtendimento}
                                        options={unidadeAtendimentoOptipons}
                                        required={true}
                                        placeholder={'Selecione a unidade...'}
                                        onChange={setUnidadeAtendimento}>
                                    </SelectComponent>
                                    {!unidadeAtendimento && campoObrigatorioHint()}
                                </FormGroup>
                            </Col>
                            <Col xl={4}>
                                <FormGroup>
                                    <Label>
                                        <IntlMessage id="Competência" />
                                    </Label>
                                    <SelectComponent
                                        value={competenciaFaturamento}
                                        options={competenciaFaturamentoOptions}
                                        required={true}
                                        placeholder={'Selecione o mês/ano da competência...'}
                                        onChange={setCompetenciaFaturamento}>
                                    </SelectComponent>
                                    {!competenciaFaturamento && campoObrigatorioHint()}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Nav tabs>
                            <NavItem>
                                <NavLink id={"tab1"}
                                    className={classnames({ active: toggleTab === '1' })}
                                    onClick={(e ) => {
                                        setToggleTab('1');
                                    }}
                                >
                                    <IntlMessage id="Anamnese/Exame Clínico" />
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink id={"tab2"} disabled={!preenchimentoValido()}
                                    className={classnames({ active: toggleTab === '2' })}
                                    onClick={() => {
                                        setToggleTab('2');
                                    }}
                                >
                                    <IntlMessage id="Avaliação pré-analítica" />

                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink id={"tab3"} disabled={!preenchimentoValido()}
                                    className={classnames({ active: toggleTab === '3' })}
                                    onClick={() => {
                                        setToggleTab('3');
                                    }}
                                >
                                    <IntlMessage id="Diagnóstico descritivo" />
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink id={"tab4"} disabled={!preenchimentoValido()}
                                    className={classnames({ active: toggleTab === '4' })}
                                    onClick={() => {
                                        setToggleTab('4');
                                    }}
                                >
                                    <IntlMessage id="Atipias Celulares" />
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink id={"tab5"} disabled={!preenchimentoValido()}
                                    className={classnames({ active: toggleTab === '5' })}
                                    onClick={() => {
                                        setToggleTab('5');
                                    }}
                                >
                                    <IntlMessage id="Resumo" />
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <div style={{ minHeight: '600px' }} id="conteudo">
                            <br />
                            <TabContent activeTab={toggleTab} >
                                <TabPane tabId="1">
                                    <Row>
                                        <Col xl={3}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Fez exame preventivo (Papanicolau) alguma vez?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={papanicolauSelecionado}
                                                    required
                                                    onChange={(e) =>{
                                                        setPapanicolauSelecionado(e);
                                                        if(e && e.value !== 'S'){
                                                            setAnoPapaNicolau('');
                                                        }
                                                    }}
                                                    placeholder='Selecione...'
                                                    styles={{ borderColor: papanicolauSelecionado ? 'transparent' : 'red' }}
                                                />
                                                {!preenchimentoValido() && !papanicolauSelecionado && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                        <Col xl={3}>
                                            <FormGroup>
                                                <Label>
                                                    <br/>
                                                    <IntlMessage id="Qual ano realizou o último exame?" />
                                                    <br/>
                                                </Label>
                                                <Input
                                                    type='number'
                                                    classename="siscolo-modal input:not([type='checkbox']):not([type='radio']):not([type='date'])"
                                                    styles={{ width: '50%' }}
                                                    disabled={!papanicolauSelecionado || papanicolauSelecionado.value !== 'S'}
                                                    required={papanicolauSelecionado && papanicolauSelecionado.value === 'S'}
                                                    value={anoPapaNicolau}
                                                    placeholder={'Informe o ano do último exame'}
                                                    mask='9999'
                                                    onChange={(e) => setAnoPapaNicolau(e.target.value)}
                                                />
                                                {!preenchimentoValido() && papanicolauSelecionado &&  papanicolauSelecionado.value === 'S' && (!anoPapaNicolau ||
                                                    anoPapaNicolau.value === '') && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                        <Col xl={6}>
                                            <FormGroup>
                                                <Label>
                                                    <br/>
                                                    <IntlMessage id="Já fez tratamento por radioterapia?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={radioTerapiaSelecionado}
                                                    required={true}
                                                    placeholder='Selecione...'
                                                    onChange={(e) => {
                                                        setRadioTerapiaSelecionado(e)
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                                {!preenchimentoValido() && !radioTerapiaSelecionado && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={3}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Usa DIU?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={diuSelecionado}
                                                    required={true}
                                                    placeholder='Selecione...'
                                                    onChange={(e) => {
                                                        setDiuSelecionado(e)
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                               {!preenchimentoValido() && !diuSelecionado && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>

                                        <Col xl={3}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Está gravida?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={gravides}
                                                    required={true}
                                                    placeholder='Selecione...'
                                                    onChange={(e) => {
                                                        setGravides(e);
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                                {!preenchimentoValido() && !gravides && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>

                                        <Col xl={3}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Sabe a data da última mestruação?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={tipoMestruacaoSeletionado}
                                                    required={true}
                                                    placeholder='Selecione...'
                                                    onChange={(e) => {
                                                        onchangeTipoMestruacao(e);
                                                          setDataUltimaMestruacao('');
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                                {!preenchimentoValido() && !tipoMestruacaoSeletionado && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                        <Col xl={3}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Data da última menstruação/regra:" />
                                                </Label>
                                                <DebounceInput
                                                    name="datamestruacao"
                                                    isClearable={true}
                                                    required={true}
                                                    disabled={!tipoMestruacaoSeletionado || tipoMestruacaoSeletionado.value !== 'S'}
                                                    type="date"
                                                    style={{ width: '130px', display: 'block' }}
                                                    className="filtro-data"
                                                    value={dataUltimaMestruacao}
                                                    onChange={(e) => {
                                                        validarDataInformada(e.target.value, setDataUltimaMestruacao);
                                                    }}
                                                />
                                                {!preenchimentoValido() && !dataUltimaMestruacao && tipoMestruacaoSeletionado && tipoMestruacaoSeletionado.value === 'S' && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={6}>
                                            <FormGroup>
                                                <Label classename="siscolo-modal .selectcomponent">
                                                    <IntlMessage id= "Tem ou teve sangramento após relações sexuais?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={sangramentoRelacaoSexual}
                                                    required={true}
                                                    placeholder = {'(não considerar o(s) sangramento(s) na vigência de reposição hormonal)'}
                                                    isClearable={true}
                                                    onChange={(e) => {
                                                        setSangramentoRelacaoSexual(e);
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                                {!preenchimentoValido() && !sangramentoRelacaoSexual && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                        <Col xl={6}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Usa pílula anticoncepcional?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={pilula}
                                                    required={true}
                                                    placeholder='Selecione...'
                                                    onChange={(e) => {
                                                        setPilula(e);
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                                {!preenchimentoValido() && !pilula && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={6}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Usa hormônio/remédio para tratar a menopausa?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    value={hormonioMenopausa}
                                                    required={true}
                                                    placeholder='Selecione...'
                                                    onChange={(e) => {
                                                        setHormonioMenopausa(e);
                                                    }}
                                                    styles={{ borderColor: 'transparent' }} />
                                                {!preenchimentoValido() && !hormonioMenopausa && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>

                                        <Col xl={6}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Tem ou teve algum sangramento após a menopausa?" />
                                                </Label>
                                                <SelectComponent
                                                    options={constantes.siscoloOptions}
                                                    required={true}
                                                    value={sangramentoAposMenopausa}
                                                    isClearable={true}
                                                    placeholder={'(não considerar o(s) sangramento(s) na vigência de reposição hormonal)'}
                                                    onChange={(e) => {
                                                        setSangramentoAposMenopausa(e);
                                                    }}
                                                    styles={{ borderColor: 'transparent' }}
                                                />
                                            {!preenchimentoValido() && !sangramentoAposMenopausa && campoObrigatorioHint()}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className='siscolo-modal'>
                                        <Row>
                                            <Col>
                                                <div className='sessao'>
                                                    <div>
                                                        <Label width='100%'>
                                                            <IntlMessage id="Exame Clínico">
                                                            </IntlMessage>
                                                        </Label>
                                                    </div>
                                                    <div className='separador'></div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={3}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Inspeção do colo" />
                                                    </Label>
                                                    <SelectComponent
                                                        options={constantes.inspecaoColoOptions}
                                                        value={inspecaoColo}
                                                        placeholder='Selecione...'
                                                        onChange={(e) => {
                                                            setInspecaoColo(e);
                                                        }}
                                                        styles={{ borderColor: 'transparent' }}
                                                    />
                                                   {!preenchimentoValido() && !inspecaoColo && campoObrigatorioHint()}
                                                </FormGroup>
                                            </Col>
                                            <Col xl={6}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Sinais sugestivos de doenças sexualmente transmissíveis?" />
                                                    </Label>
                                                    <SelectComponent
                                                        options={constantes.siscoloOptions}
                                                        value={doencaSexualmenteTransmissivel}
                                                        required={true}
                                                        placeholder='Selecione...'
                                                        isClearable={true}
                                                        styles={{ borderColor: 'transparent' }}
                                                        onChange={(e) => {
                                                            setDoencaSexualmenteTransmissivel(e);
                                                        }}
                                                    />
                                                    {!preenchimentoValido() && !doencaSexualmenteTransmissivel && campoObrigatorioHint()}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={3}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Data da coleta" />
                                                    </Label>
                                                    <DebounceInput
                                                        name="datacoleta"
                                                        isClearable={true}
                                                        required={true}
                                                        type="date"
                                                        style={{ width: '130px', display: 'block' }}
                                                        className="filtro-data"
                                                        value={dataColeta}
                                                        onChange={(e) => {
                                                            validarDataInformada(e.target.value, setDataColeta);
                                                        }}
                                                    />
                                                    {!preenchimentoValido() && !dataColeta && campoObrigatorioHint()}
                                                </FormGroup>
                                            </Col>
                                            <Col xl={3}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Data do recebimento de material" />
                                                    </Label>
                                                    <DebounceInput
                                                        name="datarecebimento"
                                                        isClearable={true}
                                                        required={true}
                                                        type="date"
                                                        style={{ width: '130px', display: 'block' }}
                                                        className="filtro-data"
                                                        value={datareRecebimentoMaterial}
                                                        onChange={(e) => {
                                                            validarDataInformada (e.target.value, setDatareRecebimentoMaterial);
                                                        }}
                                                    />
                                                    {!preenchimentoValido() && !datareRecebimentoMaterial && campoObrigatorioHint()}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </TabPane>
                                <TabPane tabId="2">
                                    <div><Row>
                                        <Col xl={6}>
                                            <FormGroup>
                                                <Label>
                                                    <IntlMessage id="Amostra rejeitada por" />
                                                </Label>
                                                <CheckBox
                                                    label={constantes.ausenciaErroIdentificacaoLabel}
                                                    required={true}
                                                    id='rejeitada'
                                                    onChange={(e) => setRejeitada(e.target.checked)}
                                                    checked={rejeitada}
                                                >
                                                </CheckBox>
                                                <CheckBox
                                                    label={constantes.laminaDanificadaouAusenteLabel}
                                                    id='danificada'
                                                    onChange={(e) => setLaminaDanificada(e.target.checked)}
                                                    checked={laminaDanificada}
                                                >
                                                </CheckBox>
                                                <br></br>
                                                <br></br>
                                                <Label>
                                                    <IntlMessage id='Causas alheias ao laboratório' />
                                                </Label>
                                                <br></br>
                                                <Input type='text' id='causasAlheiasRejeicao' value={causasAlheiasRejeicao} onChange={(e) => setCausasAlheiasRejeicao(e.target.value)}></Input>
                                                <br></br>
                                                <Label>
                                                    <IntlMessage id= 'Outras causas'/>
                                                </Label>
                                                <Input type='text' id='outrasCausasRejeicao' value={outrasCausasRejeicao}  onChange={(e) => setOutrasCausasRejeicao(e.target.value)}></Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xl={6}>
                                            <FormGroup>
                                                {/* <div id='adequabilidadematerial' style={{borderStyle: 'solid', borderColor: 'red'}}> */}
                                                <Label>
                                                    <IntlMessage id="Adequabilidade do material" />
                                                </Label>
                                                <SelectComponent
                                                    id='adequabilidade'
                                                    onChange={onChangeAdequabilidade}
                                                    value={adequabilidade}
                                                    disabled={!habiltarAdequabilidade()}
                                                    required={true}
                                                    options={constantes.adequabilidadeOptions}
                                                    placeholder='Selecione...'
                                                >
                                                </SelectComponent>
                                                {habiltarAdequabilidade() && (!adequabilidade || adequabilidade.label === '') && campoObrigatorioHint()}
                                                {/* </div> */}
                                                <br></br>
                                                <div>
                                                    <CheckBox
                                                        label={constantes.acelularHipocelularLabel}
                                                        id='acelularHipocelular'
                                                        onChange={(e) => setAcelularHipocelular(e.target.checked)}
                                                        checked={acelularHipocelular && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    <CheckBox
                                                        label={constantes.sangueEsfregacoLabel}
                                                        id='sangueEsfregaco'
                                                        onChange={(e) => setSangueEsfregaco(e.target.checked)}
                                                        checked={sangueEsfregaco && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    <CheckBox
                                                        label={constantes.pioticosEsfregacoLabel}
                                                        id='pioticosEsfregaco'
                                                        onChange={(e) => setPioticosEsfregaco(e.target.checked)}
                                                        checked={pioticosEsfregaco && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    <CheckBox
                                                        label={constantes.artefatosDessecamentoLabel}
                                                        id='artefatosDessecamento'
                                                        onChange={(e) => setArtefatosDessecamento(e.target.checked)}
                                                        checked={artefatosDessecamento && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    <CheckBox
                                                        label={constantes.contaminantesLabel}
                                                        id='contaminantes'
                                                        onChange={(e) => setContaminantes(e.target.checked)}
                                                        checked={contaminantes && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    <CheckBox
                                                        label={constantes.intensaSuperposicaoLabel}
                                                        id='superposicao'
                                                        onChange={(e) => setSuperposicao(e.target.checked)}
                                                        checked={superposicao && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    <CheckBox
                                                        label={constantes.outrosLabel}
                                                        id='outros'
                                                        onChange={(e) => setOutros(e.target.checked)}
                                                        checked={outros && habilitarCheckboxAdequabilidade() && habiltarAdequabilidade()}
                                                        disabled={!habilitarCheckboxAdequabilidade() && !habiltarAdequabilidade()}
                                                    >
                                                    </CheckBox>
                                                    {habiltarAdequabilidade() && (adequabilidade && adequabilidade.value === 'I') &&
                                                        !(outros || superposicao || contaminantes || artefatosDessecamento ||
                                                    pioticosEsfregaco || sangueEsfregaco || acelularHipocelular) && campoObrigatorioHint()}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className='siscolo-modal'>
                                        <Row>
                                            <Col xl={12}>
                                                <FormGroup>
                                                    <div className='sessao'>
                                                        <Label>
                                                            {constantes.epiteliosApresentadosLabel}
                                                        </Label>
                                                    </div>
                                                    <div className='separador'></div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={4}>
                                                <CheckBox
                                                    label={constantes.escamosoLabel}
                                                    id='escamoso'
                                                    onChange={(e) => setEscamoso(e.target.checked)}
                                                    disabled={!habilitarEpitelios()}
                                                    checked={escamoso && habilitarEpitelios()}
                                                >
                                                </CheckBox>
                                            </Col>
                                            <Col xl={4}>
                                                <CheckBox
                                                    label={constantes.glandularLabel}
                                                    id='glandular'
                                                    disabled={!habilitarEpitelios()}
                                                    onChange={(e) => setGlandular(e.target.checked)}
                                                    checked={glandular && habilitarEpitelios()}
                                                >
                                                </CheckBox>
                                            </Col>
                                            <Col xl={4}>
                                                <CheckBox
                                                    label={constantes.metaplasicoLabel}
                                                    id='metaplasico'
                                                    disabled={!habilitarEpitelios()}
                                                    onChange={(e) => setMetaplasico(e.target.checked)}
                                                    checked={metaplasico && habilitarEpitelios()}
                                                >
                                                </CheckBox>
                                            </Col>
                                        </Row>
                                        {habilitarEpitelios() && !(metaplasico || glandular || escamoso) &&
                                        (<Row>
                                            <Col xl={12}>
                                            <div>{campoObrigatorioHint()}</div>
                                            </Col>
                                        </Row>)}
                                    </div>
                                </TabPane>
                                <TabPane tabId="3">
                                    <div>
                                        <Row>
                                            <Col xl={12}>
                                                <FormGroup>
                                                    <CheckBox
                                                        label={constantes.dentroLimitesLabel}
                                                        id='limiteNormalidade'
                                                        onChange={(e) => setLimiteNormalidade(e.target.checked)}
                                                        checked={limiteNormalidade}
                                                    >
                                                    </CheckBox>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className='mv-tipo-laminas siscolo-modal row'>
                                            <Row>
                                                <Col xl={12} className='rowgroup'>
                                                    <FormGroup>
                                                        <Label>
                                                            {constantes.alteracoesCelularesBenignasReativasLabel}
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.inflamacaoLabel}
                                                        id='inflamacao'
                                                        onChange={(e) => setInflamacao(e.target.checked)}
                                                        checked={inflamacao && !limiteNormalidade}
                                                        disabled={limiteNormalidade}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={7}>
                                                    <Label>
                                                        <IntlMessage id="Outros motivos, especificar:" />
                                                    </Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.metaplasiaescamosaLabel}
                                                        id='metaplasiaescamosa'
                                                        onChange={(e) => setMetaplasiaescamosa(e.target.checked && !limiteNormalidade)}
                                                        checked={metaplasiaescamosa && !limiteNormalidade}
                                                        disabled={limiteNormalidade}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={7}>
                                                    <Input type='text' id='outrosMotivos' styles={{ width: '100%' }} disabled={limiteNormalidade} value={outrosMotivos} onChange={(e) => setOutrosMotivos(e.target.value)}></Input>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.reparacaoLabel}
                                                        id='reparacao'
                                                        onChange={(e) => setReparacao(e.target.checked && !limiteNormalidade)}
                                                        checked={reparacao && !limiteNormalidade}
                                                        disabled={limiteNormalidade}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.atrofiaInflamacaoLabel}
                                                        id='atrofiaInflamacao'
                                                        onChange={(e) => setAtrofiaInflamacao(e.target.checked && !limiteNormalidade)}
                                                        checked={atrofiaInflamacao && !limiteNormalidade}
                                                        disabled={limiteNormalidade}>
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.radiacaoLabel}
                                                        id='radiacao'
                                                        onChange={(e) => setRadiacao(e.target.checked && !limiteNormalidade)}
                                                        checked={radiacao && !limiteNormalidade}
                                                        disabled={limiteNormalidade}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>

                                            {habiltarAdequabilidade() &&
                                                !limiteNormalidade &&
                                                !(atrofiaInflamacao || radiacao || reparacao || metaplasiaescamosa || inflamacao || (outrosMotivos && outrosMotivos !== '')
                                                )  && campoObrigatorioHint()}
                                            <Row>
                                                <Col xl={12} className='rowgroup'>
                                                    <FormGroup>
                                                        <Label>
                                                            <IntlMessage id="Microbiologia" />
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.lactobacillusspLabel}
                                                        id='lactobacillus'
                                                        onChange={(e) => setLactobacillus(e.target.checked)}
                                                        checked={lactobacillus}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.trichomonasVaginalisLabel}
                                                        id='trichomonas'
                                                        onChange={(e) => setTrichomonas(e.target.checked)}
                                                        checked={trichomonas}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.cocosLabel}
                                                        id='cocos'
                                                        onChange={(e) => setCocos(e.target.checked)}
                                                        checked={cocos}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={6} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.efeitocitopaticoLabel}
                                                        id='efeitocitopatico'
                                                        onChange={(e) => setEfeitocitopatico(e.target.checked)}
                                                        checked={efeitocitopatico}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.chlamydiaSpLabel}
                                                        id='chlamydia'
                                                        onChange={(e) => setChlamydia(e.target.checked)}
                                                        checked={chlamydia}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.gardnerellaVaginalisLabel}
                                                        id='gardnerella'
                                                        onChange={(e) => setGardnerella(e.target.checked)}
                                                        checked={gardnerella}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.actinomycesSpLabel}
                                                        id='actinomyces'
                                                        isClearable = {true}
                                                        onChange={(e) => setActinomyces(e.target.checked)}
                                                        checked={actinomyces}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.bacilosLabel}
                                                        id='bacilos'
                                                        onChange={(e) => setBacilos(e.target.checked)}
                                                        checked={bacilos}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.candidaSpLabel}
                                                        id='candida'
                                                        onChange={(e) => setCandida(e.target.checked)}
                                                        checked={candida}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                                <Col xl={6} className='rowgroup'>
                                                    <CheckBox
                                                        label={constantes.bacilossupracitopaticosLabel}
                                                        id='baciloSupracitopaticos'
                                                        onChange={(e) => setBaciloSupracitopaticos(e.target.checked)}
                                                        checked={baciloSupracitopaticos}
                                                    >
                                                    </CheckBox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={4} className='rowgroup'>
                                                    <Label>
                                                        <IntlMessage id="Outros motivos, especificar:"/>
                                                    </Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={12} className='rowgroup'>
                                                    <Input type='text' id='outrosMotivosMicrobiologia' styles={{ width: '100%' }} value={outrosMotivosMicrobiologia} onChange={(e) => setOutrosMotivosMicrobiologia(e.target.value)}></Input>
                                                </Col>
                                            </Row>
                                        </div>
                                        {/* {!preenchimentoValido() && campoObrigatorioHint()} */}
                                    </div>
                                </TabPane>
                                <TabPane  tabId="4" >
                                    <div className='mv-tipo-laminas siscolo-modal row'>
                                        <div className='rowgroup'>
                                            <Label>
                                                <IntlMessage id="Células atipias de significado indeterminado" />
                                            </Label>
                                        </div>
                                        <Row>
                                            <Col xl={4}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Escamosas" />
                                                    </Label>
                                                    <SelectComponent
                                                        id='celulaEscamosa'
                                                        value={celulaEscamosa}
                                                        onChange={e => {
                                                            setCelulaEscamosa(e);
                                                            if (e && e.value !== 'X'){
                                                                setAtipiasCelulasEscamosas(constantes.atipiasEmCelupasEscamosasOptions.find(x => x.value === 'X'));
                                                            }
                                                        }
                                                    }
                                                    options={constantes.tiposcelupasatipiasOtions}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xl={4} >
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Glandulares" />
                                                    </Label>
                                                    <SelectComponent
                                                        id='celulaGanlurares'
                                                        value={celulaGanlurares}
                                                        onChange={e => {
                                                            setCelulaGanlurares(e)
                                                            if( e && e.value !== 'X'){
                                                                setAtipiasCelulasGlandulares(constantes.atipiasEmCelupasGlandularesOptions.find(x => x.value === 'X'))
                                                            }
                                                        }}
                                                        options={constantes.tiposcelupasatipiasOtions}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xl={4}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Origem indefínida" />
                                                    </Label>
                                                    <SelectComponent
                                                        id='celulaOrigemIndefinida'
                                                        value={celulaOrigemIndefinida}
                                                        onChange={e => {
                                                            setCelulaOrigemIndefinida(e)
                                                        }}
                                                        options={constantes.tiposcelupasatipiasOtions} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className='mv-tipo-laminas siscolo-modal row'>
                                        <Row>
                                            <Col xl={6}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Atipias em células escamosas" />
                                                    </Label>
                                                    <SelectComponent
                                                        id='atipiasCelulasEscamosas'
                                                        value={atipiasCelulasEscamosas}
                                                        onChange={e => {
                                                            setAtipiasCelulasEscamosas(e)
                                                        }}
                                                        options={constantes.atipiasEmCelupasEscamosasOptions}
                                                        //disabled={celulaEscamosa && celulaEscamosa.value !== 'X'}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xl={6}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Atipias em células glandulares" />
                                                    </Label>
                                                    <SelectComponent
                                                        id='atipiasCelulasGlandulares'
                                                        value={atipiasCelulasGlandulares}
                                                        onChange={e => setAtipiasCelulasGlandulares(e)}
                                                        options={constantes.atipiasEmCelupasGlandularesOptions}
                                                        disabled={celulaGanlurares && celulaGanlurares.value !== 'X'}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className='siscolo-modal'>
                                        <Row>
                                            <Col xl={12}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Outras neoplasias malignas" />
                                                    </Label>
                                                    <Input type='text' className='siscolo-textObs' value={outrasNeoplasiasMalignas} onChange={(e) => setOutrasNeoplasiasMalignas(e.target.value)} id='outrasNeoplasiasMalignas'> </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={12}>
                                                <FormGroup>
                                                    <CheckBox id='celulaEndometria' value={celulaEndometria} onChange={e => setCelulaEndometria(e.target.checked)}></CheckBox>
                                                    <CheckBox
                                                        label={constantes.presencaCelulasendometraisLabel}
                                                        id='celulaEndometria'
                                                        onChange={(e) => setCelulaEndometria(e.target.checked)}
                                                        checked={celulaEndometria}
                                                    ></CheckBox>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={12}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Observações gerais" />
                                                    </Label>
                                                    <Input
                                                        type='text'
                                                        styles={{ height: '122px !important%' }}
                                                        value={observacaosGerais}
                                                        onChange={(e) => setObservacacaosGerais(e.target.value)}
                                                        className='InputTextObs' id='observacaosGerais'>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={4}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Data da liberação do resultado" />
                                                    </Label>
                                                    <DebounceInput
                                                        name="dataLiberacao"
                                                        isClearable={true}
                                                        required={true}
                                                        type="date"
                                                        style={{ width: '130px', display: 'block' }}
                                                        className="filtro-data"
                                                        value={dataLiberacao}
                                                        onChange={e => {
                                                           validarDataInformada (e.target.value, setDataLiberacao);
                                                        }}
                                                    />
                                                    {!preenchimentoValido() &&  !dataLiberacao && campoObrigatorioHint()}
                                                </FormGroup>
                                            </Col>
                                            <Col xl={8}>
                                                <FormGroup>
                                                    <Label>
                                                        <IntlMessage id="Médico responsavél do resultado" />
                                                    </Label>
                                                    <SelectComponent
                                                        id='medicoResponsavel'
                                                        value={medicoResponsavel}
                                                        onChange={e => setMedicoResponsavel(e)}
                                                        options={medicoResponsavelOptions} />
                                                    {!preenchimentoValido() &&  !dataLiberacao && campoObrigatorioHint()}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </TabPane>
                                <TabPane tabId="5">
                                    <Row rows={12}>
                                        <Col>
                                            <EditorContainer history={history} />
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                    <CheckBox
                        label='Enviar informação para MV'
                        id='enviaInfoMv'
                        onChange={(e) => setEnviaInfoMv(e.target.checked)}
                        checked={enviaInfoMv}
                    ></CheckBox>
                        {toggleTab !== '5' && (<Button
                            className='modalComponente-novo'
                            color='primary'
                            disabled={!preenchimentoValido()}
                            onClick={() => toggle(parseInt(toggleTab) + 1)}
                        >
                            <IntlMessage id="general.login.next" />
                        </Button>)}

                        {toggleTab === '5' && (<Button
                            className='modalComponente-novo'
                            color='secondary'
                            disabled={!preenchimentoValido()}
                            onClick={() => substituirTextoEditor(constantes.templateRtfSiscolo)}
                        >
                            <IntlMessage id="Atualizar resumo" />
                        </Button>)}

                        {toggleTab === '5' && (<Button
                            className='modalComponente-novo'
                            color='primary'
                            type='submit'
                            disabled={!preenchimentoValido()}
                            onClick={(e) => salvar(e)}
                        >
                            <IntlMessage id="Salvar" />
                        </Button>)}

                        <Button
                            className='modalComponente-fechar'
                            color='secondary'
                            onClick={props.toggle}
                        >
                            <IntlMessage id="dashboards.examDetail.close" />
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { detalhesLaudo, laudo, isOpen, toggle },
        dispatch
    );
};

export default connect(mapStateToProps)(SiscoloModal);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/microscopia/modal/siscolo.modal.js